import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";
import { useState } from "react";
import { Col, Row } from "react-bootstrap";
import GradientButton from "../../../Core/GradientButton";
import { useNavigate } from "react-router-dom";
import { useSessionStore } from "../../../../Stores/SessionStore";
import BusyIndicator from "../../../Core/BusyIndicator";
import CannotRechargeWarningModal from "../../../Core/CannotRechargeWarningModal";
import PageTitle from "../../../Core/PageTitle";
import CancelSubscriptionModal from "./CancelSubscriptionModal";
import SubscriptionPaymentFailedModal from "./SubscriptionPaymentFailedModal";
import ComingSoonModal from "./ComingSoonModal";
import PackageDetails from "./PackageDetails";
import RechargeHistory from "./RechargeHistory";
import FlashAccountPaymentsTable from "./FlashAccountPaymentsTable";
import UserProfileDetails from "./UserProfileDetails";
import RICAModal from "./RICAModal";
import ChangeWiFiPasswordModal from "./ChangeWifFiPasswordModal.tsx";
import InstallationPendingModal from "./InstallationPendingModal";
import AlertModal from "../../../Core/AlertModal";

const Home = observer(function Home(props) {
	const [showComingSoonModal, setShowComingSoonModal] = useState(false);
	const [showCannotRechargeModal, setShowCannotRechargeModal] = useState(false);
	const [showCancelSubscriptionModal, setShowCancelSubscriptionModal] = useState(false);
	const [showRICAModal, setShowRICAModal] = useState(false);
	const [showChangeWiFiPasswordModal, setShowChangeWiFiPasswordModal] = useState(false);
	const [showInstallationPendingModal, setShowInstallationPendingModal] = useState(false);
	const [showAlertModal, setShowAlertModal] = useState(false);

	const store = useSessionStore();
	const navigate = useNavigate();

	useEffect(() => {
		async function getDetails() {
			store.LoadCustomerDetails();	
		}

		getDetails();
	}, []);

	function handleCancelSubscriptionModalClosed(refresh) {
		setShowCancelSubscriptionModal(false);

		if(refresh) {
			store.LoadCustomerDetails();
		}
	}

	function handleSubscriptionPaymentFailedModalClosed(recharge) {
		store.SetSubscriptionStatusActive(store.CustomerDetails.SubscriptionStatus === "ACTIVE" || store.CustomerDetails.SubscriptionStatus === "COMPLETE");
		
		if (recharge) handleRechargeClicked();
	}

	function handleRechargeClicked() {
		
		if (store?.CustomerDetails?.Address === null ||
			(store?.CustomerDetails?.Address && store?.CustomerDetails?.Address?.InstallDate === null)
		) {
			setShowInstallationPendingModal(true);
			return;
		} else if (
			store?.CustomerDetails?.Address &&
			store?.CustomerDetails?.Address?.InstallDate !== null && 
			!store?.CustomerDetails?.Customer.RegistrationApproved && 
			!store?.CustomerDetails?.Customer.RegistrationDeclined && 
			store?.CustomerDetails?.Customer.IDDocumentId === null
		) {
			setShowRICAModal(true);
		} else if (
			store?.CustomerDetails?.Address &&
			store?.CustomerDetails?.Address?.InstallDate !== null && 
			!store?.CustomerDetails?.Customer.RegistrationApproved && 
			store?.CustomerDetails?.Customer.RegistrationDeclined && 
			store?.CustomerDetails?.Customer.IDDocumentId === null
		) {
			navigate(`/Resubmit/${store.CustomerDetails.Customer.Id}`);
		} else if (
			store?.CustomerDetails?.Address &&
			store?.CustomerDetails?.Address?.InstallDate !== null && 
			!store?.CustomerDetails?.Customer.RegistrationApproved && 
			store?.CustomerDetails?.Customer.RegistrationDeclined && 
			store?.CustomerDetails?.Customer.IDDocumentId !== null
		) {
			setShowAlertModal(true);
		} else {
			navigate("../Recharge");
		}
	}

	function getPurchaseButtonText() {
		const { CustomerDetails } = store;

		if (CustomerDetails.Customer.RegistrationDeclined === true && CustomerDetails.Customer.IDDocumentId !== null && CustomerDetails.Customer.ProofOfAddressId !== null) {
			return "RICA Pending";
		}
		
		if (!CustomerDetails?.Address) {
			return "Start Your Free Trial";
		}
		
		if (!CustomerDetails.Address.InstallDate) {
			return "Start Your Free Trial";
		}
		
		if (CustomerDetails.Address.ExistingRICACustomer === false 
			 && !CustomerDetails.Customer?.RegistrationDeclined
			&& !CustomerDetails.Customer?.IDDocumentId
		) {
			return "Start Your Free Trial";
		}
		
		return "Purchase";
	}

	return 	<div>
				{
					store.CustomerDetails &&
					<React.Fragment>
						<PageTitle text="Customer Dashboard"></PageTitle>						
						<Row className="mb-4">
							<Col xs={12} lg={4} className="mb-3">
								{(!store.CustomerDetails.Customer.SubscriptionToken ||
									!(store.CustomerDetails.SubscriptionStatus === "ACTIVE" ||
										store.CustomerDetails.SubscriptionStatus === "COMPLETE")) && (
									<GradientButton
										title={getPurchaseButtonText()}
										variant="greenYellow"
										onClick={handleRechargeClicked}
										disabled={store.CustomerDetails.RadiusDetails?.ServiceId === 7}
									/>
								)}
								{store.CustomerDetails.RadiusDetails?.ServiceId !== 7 &&
									store.CustomerDetails.Customer.SubscriptionToken &&
									(store.CustomerDetails.SubscriptionStatus === "ACTIVE" ||
										store.CustomerDetails.SubscriptionStatus === "COMPLETE") && (
									<GradientButton
										title="Cancel Subscription"
										variant="yellowOrange"
										onClick={() => setShowCancelSubscriptionModal(true)}
									/>
								)}
							</Col>
							<Col xs={12} lg={4} className="mb-3">
								<GradientButton
									title="Change WiFi Details"
									variant="greenYellow"
									disabled={!store?.CustomerDetails?.Address?.InstallDate}
									onClick={() => {
										if (!store?.CustomerDetails?.Address?.InstallDate) return;
										setShowChangeWiFiPasswordModal(true);
									}}
								/>
							</Col>
							<Col xs={12} lg={4} className="mb-3">
								<GradientButton title="Edit User Profile" variant="greenYellow" onClick={() => navigate("../Profile")} />
							</Col>
						</Row>
						<Row className="mb-4">
							<Col xs={12} lg={6} className="mb-3">
								<PackageDetails details={store.CustomerDetails} />
							</Col>
							<Col xs={12} lg={6} className="mb-3">
								<UserProfileDetails details={store.CustomerDetails} />
							</Col>
						</Row>
						<Row>
							<Col className="mb-3">
								<FlashAccountPaymentsTable />
							</Col>
						</Row>
						<Row>
							<Col className="mb-3">
								<RechargeHistory rechargeHistory={store.CustomerDetails.Customer.SuccessfulRecharges} />
							</Col>
						</Row>
						<CancelSubscriptionModal onClose={ handleCancelSubscriptionModalClosed } show={ showCancelSubscriptionModal } details={ store.CustomerDetails }></CancelSubscriptionModal>
						<SubscriptionPaymentFailedModal onClose={ handleSubscriptionPaymentFailedModalClosed } show={ store.SubscriptionStatus === null && store.CustomerDetails.SubscriptionStatus !== null && !(store.CustomerDetails.SubscriptionStatus === "ACTIVE" || store.CustomerDetails.SubscriptionStatus === "COMPLETE") } details={ store.CustomerDetails }></SubscriptionPaymentFailedModal>
					</React.Fragment>
				}
				<BusyIndicator show={ store.CustomerDetails === null }></BusyIndicator>
				<ComingSoonModal show={ showComingSoonModal } onOKClicked={ e => setShowComingSoonModal(false) }></ComingSoonModal>
				<CannotRechargeWarningModal show={ showCannotRechargeModal } onOKClicked={ e => setShowCannotRechargeModal(false) }></CannotRechargeWarningModal>
				<InstallationPendingModal show={ showInstallationPendingModal } onOKClicked={ e => setShowInstallationPendingModal(false) }></InstallationPendingModal>
				{showRICAModal && <RICAModal show={ showRICAModal } onOKClicked={ e => {setShowRICAModal(false); store.LoadCustomerDetails();} }></RICAModal>}
				{showChangeWiFiPasswordModal && <ChangeWiFiPasswordModal show={ showChangeWiFiPasswordModal } onClose={ e => setShowChangeWiFiPasswordModal(false) }></ChangeWiFiPasswordModal>}
				{showAlertModal && <AlertModal modal={ { show: showAlertModal, onClose: () => setShowAlertModal(false), success: true, title: "RICA Pending", message: "Your RICA information is being reviewed. We will notify you once the review is complete or you can contact Zing support via WhatsApp on 087 056 1218" } }></AlertModal>}
			</div>
});

export default Home;